<div class="uw-dialog-header">
  <h1 class="uw-dialog-heading">{{ "catalog.edit_catalog_maintenance_record" | translate }}</h1>

  <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
    <mat-icon>
      close
    </mat-icon>
  </button>
</div>

<div class="uw-dialog-content" [formGroup]="form">

  <div class="uw-field">
    <label for="city" class="uw-label">
      {{ "common.city" | translate }}
    </label>
    <input id="city" type="text" class="uw-input" formControlName="city">
    @if (!form.pristine && form.get('city')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>

  <div class="uw-field">
    <label for="prov" class="uw-label">
      {{ "common.province" | translate }}
    </label>
    <input id="prov" type="text" class="uw-input" formControlName="prov">
    @if (!form.pristine && form.get('prov')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>

  <div class="uw-field">
    <label for="suWay" class="uw-label">
      SuWay
    </label>
    <input id="suWay" type="text" class="uw-input" formControlName="suWay">
    @if (!form.pristine && form.get('suWay')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>

  <div class="uw-field">
    <label for="drCode" class="uw-label">
      DrCode
    </label>
    <input id="drCode" type="text" class="uw-input" formControlName="drCode">
    @if (!form.pristine && form.get('drCode')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>
</div>

<div class="uw-dialog-footer">
  <div class="uw-actions">

    <button class="uw-stroked-button" mat-dialog-close>
      {{ "common.cancel" | translate }}
    </button>

    <button class='uw-default-button' [disabled]="form.pristine || !form.valid" (click)="handleSave(form.value)">
      {{ "common.save" | translate }}
    </button>

  </div>
</div>


